import * as React from 'react';
type Props = {
  className?: string;
};
export function CheckboxOn({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-checkbox-on"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 3C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6C3 4.34315 4.34315 3 6 3H18ZM16.6066 7.5L10.242 13.864L7.41421 11.0355L6 12.4497L10.2426 16.6924L18.0208 8.91421L16.6066 7.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
